import { Order } from '@webapp/types/orders/order';
import { Coupon } from '@services/product/types/coupon';

export const getFinalPrice = (basket: Order[], activeCoupon?: Coupon) => {
  const amount = basket.reduce((total, order) => {
    const discountRatio = activeCoupon ? 1 - activeCoupon.percent_off / 100 : 1;
    const value = discountRatio * ((order.price.value * order.quantity) / 100);
    return total + value;
  }, 0);

  return amount.toFixed(2);
};
